import React, { useState, useRef } from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { groupnames } from '../../../libraries/filters';
import { updateDocumentProperty } from '../../../services/firestore';
import { db } from '../../../services/firebase';
import { uploadFileToDigitalOcean, deleteFileFromDigitalOcean } from '../../../services/digitalOcean';

const AdminStudyAdminUserProfile = ({user}) => {
    const [refresh, setRefresh] = useState(false);
    const [region, setRegion] = useState(user.region);
    const [uploadStatus, setUploadStatus] = useState("");
    const fileInputRef = useRef(null);
    const regions = [
        'Undefined',
        'Toronto',
        'Vancouver',
        'Montreal',
        'Calgary',
        'Edmonton'
    ]

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.type !== 'application/pdf') {
            setUploadStatus("Please upload a PDF file");
            return;
        }

        try {
            setUploadStatus("Uploading...");
            const sanitizedEmail = user.email.replace(/[^a-zA-Z0-9]/g, '_');
            const filePath = `docs/personalized/${sanitizedEmail}/personalized.pdf`;
            
            await uploadFileToDigitalOcean(file, filePath);
            setUploadStatus("Upload successful!");
            
            // Update user document with PDF path
            await updateDocumentProperty(db, "users", user.uid, "personalizedPdfPath", filePath);
            
            // Clear the file input
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            setUploadStatus("Upload failed. Please try again.");
        }
    };

    const handleRemovePdf = async () => {
        if (!user.personalizedPdfPath) return;

        try {
            setUploadStatus("Removing PDF...");
            await deleteFileFromDigitalOcean(user.personalizedPdfPath);
            await updateDocumentProperty(db, "users", user.uid, "personalizedPdfPath", null);
            setUploadStatus("PDF removed successfully!");
        } catch (error) {
            console.error("Error removing PDF:", error);
            setUploadStatus("Failed to remove PDF. Please try again.");
        }
    };

    const MakeRegionalAdmin = () => {
        updateDocumentProperty(db, "users", user.uid, "isRegionalAdmin", true);
        setRefresh(!refresh);
    }

    const RemoveRegionalAdmin = () => {
        if (user.isSiteAdmin) {
            return;
        }
        updateDocumentProperty(db, "users", user.uid, "isRegionalAdmin", false);
        setRefresh(!refresh);
    }

    const MakeStudyAdmin = () => {
        updateDocumentProperty(db, "users", user.uid, "isStudyAdmin", true);
        setRefresh(!refresh);
    }

    const RemoveStudyAdmin = () => {
        if (user.isSiteAdmin) {
            return;
        }
        updateDocumentProperty(db, "users", user.uid, "isStudyAdmin", false);
        setRefresh(!refresh);
    }

    const UpdateRegion = (target) => {
        setRegion(target.value);
        updateDocumentProperty(db, "users", user.uid, "region", target.value);
        setRefresh(!refresh);
    }

    const SetArchived = (value) => {
        updateDocumentProperty(db, "users", user.uid, "isArchived", value);
        setRefresh(!refresh);
    }

    const DeleteAccount = () => {
        if (user.isSiteAdmin || !user.isArchived) {
            return;
        }
        db.collection("users").doc(user.uid).delete();
    }

    return ( 
        <StyledRow key={user.id}>
            <Col xs="4">
                <p><b>Username: </b>{user.username}</p>
                <p><b>Email: </b>{user.email}</p>
                <div>
                    <b>Personalized PDF: </b>
                    <Input
                        type="file"
                        accept=".pdf"
                        onChange={handleFileUpload}
                        innerRef={fileInputRef}
                        style={{ marginTop: '10px' }}
                    />
                    {uploadStatus && <p style={{ color: uploadStatus.includes('failed') ? 'red' : 'green' }}>{uploadStatus}</p>}
                    {user.personalizedPdfPath && (
                        <div>
                            <a 
                                href={`https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/${user.personalizedPdfPath}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: '10px' }}
                            >
                                View Current PDF
                            </a>
                            <StyledButton onClick={handleRemovePdf} color="danger" size="sm">
                                <FAIconButton icon={["fas", "trash"]}></FAIconButton>
                                Remove PDF
                            </StyledButton>
                        </div>
                    )}
                </div>
            </Col>
            <Col xs="3">
                <div><b>Region: {user.region}</b></div>
                {/*
                <StyledInput style={{ marginBottom:'15px'}} value={region} type="select" name="region" id="region" onChange={(e) => UpdateRegion(e.target)}>
                    {regions.map((region) => (
                        <option  key={region} value={region}>
                            {region}
                        </option>
                    ))}
                </StyledInput>
                    */}
            </Col>
            <FlexCol>
                {/*
                {!user.isSiteAdmin && ((user.isRegionalAdmin === undefined || !user.isRegionalAdmin) ? <StyledButton onClick={() => MakeRegionalAdmin()} color="primary">
                    <FAIconButton  icon={["fas", "check"]}></FAIconButton>Make Regional Admin
                </StyledButton> : <StyledButton onClick={() => RemoveRegionalAdmin()} color="primary">
                    <FAIconButton  icon={["fas", "exclamation-circle"]}></FAIconButton>Remove Regional Admin
                </StyledButton>)}
                {!user.isSiteAdmin && ((user.isStudyAdmin === undefined || !user.isStudyAdmin) ? <StyledButton onClick={() => MakeStudyAdmin()} color="primary">
                    <FAIconButton  icon={["fas", "check"]}></FAIconButton>Make Study Admin
                </StyledButton> : <StyledButton onClick={() => RemoveStudyAdmin()} color="primary">
                    <FAIconButton  icon={["fas", "exclamation-circle"]}></FAIconButton>Remove Study Admin
                </StyledButton>)}
                    */}
                {!user.isSiteAdmin && ((user.isArchived === undefined || !user.isArchived) ? <StyledButton onClick={() => SetArchived(true)} color="warning">
                    <FAIconButton  icon={["fas", "exclamation-circle"]}></FAIconButton>Archive Account
                </StyledButton> : <StyledButton onClick={() => SetArchived(false)} color="warning">
                    <FAIconButton  icon={["fas", "exclamation-circle"]}></FAIconButton>Unarchive Account
                </StyledButton>)}
                {!user.isSiteAdmin && user.isArchived && <StyledButton onClick={() => DeleteAccount()} color="danger">
                    <FAIconButton  icon={["fas", "exclamation-circle"]}></FAIconButton>Delete Account (not reverseable!)
                </StyledButton>}
            </FlexCol>
            <hr />
        </StyledRow> );
}

export default AdminStudyAdminUserProfile;

const FlexCol = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
`

const StyledRow = styled(Row)`
    height: auto;
`

const FAIconButton = styled(FontAwesomeIcon)`
    margin-right: 8px;
    margin-left: 8px;
`;

const StyledButton = styled(Button)`
    margin-bottom: 3px;
    margin-left: 5px;
    max-height: 36px;
    border-style: solid;
    border-width: 1.5px;
    border-color: black;
`;

const StyledInput = styled(Input)`
&:focus{
    border-color: #372844;
    box-shadow: 0 0.5rem 1rem #9780af;
}

appearance: menulist;
`